export enum DailyActivityItemStatus {
  Received = 1,
  NotReceived = 2,
  CanReceive = 3,
}
